import AceitePanel from './AceitePanel';

export default AceitePanel;
